import { useEffect, useState } from 'react';

const useWindowLocation = (regex: RegExp): boolean => {
  const [isTarget, setIsTarget] = useState<boolean>(regex.test(window.location.pathname));

  useEffect(() => {
    const onChange = (): void => setIsTarget(regex.test(window.location.pathname));

    window.addEventListener('popstate', onChange);

    return (): void => {
      window.removeEventListener('popstate', onChange);
    };
  }, [regex]);

  return isTarget;
};

export const useIsEvent = (): boolean =>
  useWindowLocation(new RegExp(/\/pro\/top-stocks-(\d{2})-investor-summit/));

export const useIsPublic = (): boolean => useWindowLocation(new RegExp(/\/public\//));

export const useIsHome = (): boolean => useWindowLocation(new RegExp(/pro$/));
export const useIsHomeWithPage = (): boolean => useWindowLocation(new RegExp(/pro\/page\/\d+/));
